import { render, staticRenderFns } from "./ManageAudiences.vue?vue&type=template&id=38031458&"
import script from "./ManageAudiences.vue?vue&type=script&lang=ts&"
export * from "./ManageAudiences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports